module.exports = __webpack_public_path__ + "img/TZA.a0cb9e9c.svg";